import { createAsyncAction } from "typesafe-actions";
import { Form, Hospital, RolePermission } from "@shared/models";
import { Filter, PaginatedResponse } from "@shared/interfaces";

import { HospitalActionTypes } from "./constants";
import { UpdateHospitalPermissionPayload, UpdateHospitalPermissionSuccess, UpdateHospitalSuccess } from "../interfaces";

export const getHospitals = createAsyncAction(
  HospitalActionTypes.GET_HOSPITALS,
  HospitalActionTypes.GET_HOSPITALS_SUCCESS,
  HospitalActionTypes.GET_HOSPITALS_FAILURE,
)<Filter, PaginatedResponse<Hospital>, Error>();

export const getHospital = createAsyncAction(
  HospitalActionTypes.GET_HOSPITAL,
  HospitalActionTypes.GET_HOSPITAL_SUCCESS,
  HospitalActionTypes.GET_HOSPITAL_FAILURE,
)<{ id: number }, Hospital | null, Error>();

export const getHospitalFormsSettings = createAsyncAction(
  HospitalActionTypes.GET_HOSPITAL_FORMS_SETTINGS,
  HospitalActionTypes.GET_HOSPITAL_FORMS_SETTINGS_SUCCESS,
  HospitalActionTypes.GET_HOSPITAL_FORMS_SETTINGS_FAILURE,
)<{ id: number }, Form[], Error>();

export const getHospitalPermissions = createAsyncAction(
  HospitalActionTypes.GET_HOSPITAL_PERMISSIONS,
  HospitalActionTypes.GET_HOSPITAL_PERMISSIONS_SUCCESS,
  HospitalActionTypes.GET_HOSPITAL_PERMISSIONS_FAILURE,
)<{ id: number }, RolePermission[], Error>();

export const updateHospitalPermission = createAsyncAction(
  HospitalActionTypes.UPPDATE_HOSPITAL_PERMISSION,
  HospitalActionTypes.UPPDATE_HOSPITAL_PERMISSION_SUCCESS,
  HospitalActionTypes.UPPDATE_HOSPITAL_PERMISSION_FAILURE,
)<UpdateHospitalPermissionPayload, UpdateHospitalPermissionPayload & UpdateHospitalPermissionSuccess, Error>();

export const updateHospital = createAsyncAction(
  HospitalActionTypes.UPDATE_HOSPITAL,
  HospitalActionTypes.UPDATE_HOSPITAL_SUCCESS,
  HospitalActionTypes.UPDATE_HOSPITAL_FAILURE,
)<Partial<Hospital>, UpdateHospitalSuccess, Error>();
